import React, {Fragment} from 'react'
import Slider from 'react-slick';
import { SLICK_BREAKPOINT_KEY } from '../../constants/slickBreakpoints';

const feedbackContent = [
    {
        img: 'author-6c',
        desc: 'CODAM의 보안 취약점 점검 서비스를 통해 기존 시스템의 위험 요소를 조기에 발견하고 조치할 수 있었습니다. 보안 리포트가 매우 상세하고 실무에 바로 적용 가능했습니다.',
        name: '이승민',
        desig: '제조기업 IT 보안 담당자',
        rating: '5.0'
    }, {
        img: 'author-7c',
        desc: 'AWS 클라우드 환경의 보안 아키텍처 설계와 IAM 정책 최적화를 통해 시스템 접근 제어가 크게 개선되었습니다. 전문성과 신속한 대응이 인상적이었습니다.',
        name: '박유진',
        desig: '핀테크 스타트업 CTO',
        rating: '5.0'
    }, {
        img: 'author-8c',
        desc: 'ISMS 인증 취득 과정에서 CODAM의 지원이 결정적이었습니다. 컴플라이언스 요건 분석부터 기술 조치까지 원스톱으로 처리해주어 준비 기간이 크게 단축되었습니다.',
        name: '정다은',
        desig: '의료플랫폼 개발팀장',
        rating: '5.0'
    }, {
        img: 'author-6c',
        desc: '웹 애플리케이션 보안 점검 후 발견된 취약점에 대한 조치 가이드와 코드 레벨 개선 방향 제시가 매우 도움이 되었습니다. 단순 리포트가 아닌 실질적인 해결책을 제공합니다.',
        name: '김현우',
        desig: '이커머스 플랫폼 보안팀',
        rating: '4.5'
    }, {
        img: 'author-7c',
        desc: '보안 교육 프로그램이 실무 중심으로 구성되어 임직원들의 만족도가 높았습니다. 이론이 아닌 실제 공격 사례 기반 교육으로 보안 의식이 눈에 띄게 향상되었습니다.',
        name: '최준호',
        desig: '공공기관 정보보안 팀장',
        rating: '5.0'
    }
];

const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    [SLICK_BREAKPOINT_KEY]: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 575, settings: { slidesToShow: 1 } }
    ]
};

const FeedbackThree = () => {
    return (
        <Fragment>
            <Slider {...settings} className="row gx-0 px-0 feedback-slider-three" data-aos="fade-up">
                {feedbackContent.map((val, i) => (
                    <div key={i} className="col-lg-4">
                        <div className="feedback-style-three text-center">
                            <img src={`assets/img/testimonial/${val.img}.jpg`} alt={`${val.name} 프로필`}/>
                            <div className="rating mt-30 mb-10">
                                <a href="#"><i className="bi bi-star-fill"/></a>
                                <a href="#"><i className="bi bi-star-fill"/></a>
                                <a href="#"><i className="bi bi-star-fill"/></a>
                                <a href="#"><i className="bi bi-star-fill"/></a>
                                <a href="#"><i className="bi bi-star-half"/></a>
                                <span>{val.rating}</span>
                            </div>
                            <p>{val.desc}</p>
                            <h4>{val.name}</h4>
                            <p className="text-white">{val.desig}</p>
                        </div>
                    </div>
                ))}
            </Slider>
        </Fragment>
    )
}

export default FeedbackThree
